export const PROCHAINE_TACHE_TERMINE = "TERMINE";

export const OPTION_TACHES_TERMINEES = {
  id: PROCHAINE_TACHE_TERMINE,
  name: "Toutes les tâches terminées",
};

const parcoursDuProduit = (leadTasks, ordresParProduit, produit) => {
  const ordre = ordresParProduit.get(produit) || [];
  const tachesDuProduit = leadTasks.filter((t) => t.products.includes(produit));
  const ordonnees = ordre
    .map((id) => tachesDuProduit.find((t) => t.id === id))
    .filter(Boolean);
  const horsParcours = tachesDuProduit.filter((t) => !ordre.includes(t.id));
  return [...ordonnees, ...horsParcours];
};

export const construireGroupesProchaineTache = (
  leadTasks = [],
  defaultOrderByProduct = [],
  produits = [],
  valeurActive = ""
) => {
  const ordresParProduit = new Map(
    (Array.isArray(defaultOrderByProduct) ? defaultOrderByProduct : []).map(
      (o) => [o.produit, o.taches]
    )
  );

  const parcours = produits.map((produit) => ({
    produit,
    taches: parcoursDuProduit(leadTasks, ordresParProduit, produit),
  }));

  const nbProduitsParTache = new Map();
  parcours.forEach(({ taches }) =>
    taches.forEach((t) =>
      nbProduitsParTache.set(t.id, (nbProduitsParTache.get(t.id) || 0) + 1)
    )
  );

  const groupes = [];

  if (produits.length > 1) {
    const communes = [];
    parcours.forEach(({ taches }) =>
      taches.forEach((t) => {
        if (
          nbProduitsParTache.get(t.id) > 1 &&
          !communes.some((c) => c.id === t.id)
        ) {
          communes.push(t);
        }
      })
    );
    if (communes.length) {
      groupes.push({ label: "Communes", taches: communes });
    }
  }

  parcours.forEach(({ produit, taches }) => {
    const specifiques =
      produits.length > 1
        ? taches.filter((t) => nbProduitsParTache.get(t.id) === 1)
        : taches;
    if (specifiques.length) {
      groupes.push({ label: produit.toUpperCase(), taches: specifiques });
    }
  });

  if (
    valeurActive &&
    valeurActive !== PROCHAINE_TACHE_TERMINE &&
    !groupes.some((g) => g.taches.some((t) => t.id === valeurActive))
  ) {
    const tache = leadTasks.find((t) => t.id === valeurActive);
    if (tache) {
      groupes.push({
        label: (tache.products[0] || "").toUpperCase(),
        taches: [tache],
      });
    }
  }

  return groupes;
};
